import {useBreakpoints} from "hooks";
import {useTheme} from "styled-components";
import {Column, Line, Typography, Image} from "components";

interface PrivacyProps {}

export const Privacy: React.FC<PrivacyProps> = () => {
  const {container, blackWhite} = useTheme();
  const {upXl} = useBreakpoints();
  return (
    <Column margin="2rem auto" width={upXl ? "1200px" : "95%"}>
      <Image
        width={300}
        height={60}
        margin="0 auto"
        objectFit="contain"
        src="/images/logo-horizontal.png"
      />
      <Column
        gap={0}
        width="100%"
        padding="2rem"
        borderRadius={15}
        backgroundColor={container}
      >
        <Typography fontFamily="Rubik-SemiBold" fontSize={18}>
          <strong style={{fontFamily: "Rubik-SemiBold"}}>
            CONDICIONES DE USO DE EMPRENDE YA
          </strong>
        </Typography>
        <div style={{color: blackWhite, marginTop: "0.5rem"}}>
          Bienvenido/a a Emprende Ya. Al registrarte, acceder o utilizar nuestra
          aplicación, aceptas cumplir estas Condiciones de Uso. Si no estás de
          acuerdo con ellas, no utilices la plataforma.
        </div>
        <ol style={{padding: "1rem"}}>
          <li style={{color: blackWhite}}>
            <strong style={{fontFamily: "Rubik-Medium"}}>
              Objeto del servicio
            </strong>
            <div>
              Emprende Ya es una aplicación que tiene como finalidad (describe
              brevemente: conectar emprendedores, brindar capacitaciones,
              ofrecer herramientas y recursos, etc.). Dependiendo de la
              funcionalidad de la app, el usuario podrá acceder a contenido
              educativo, interactuar con otros usuarios, participar en
              comunidades y utilizar herramientas de gestión para su
              emprendimiento.
            </div>
          </li>
          <li style={{color: blackWhite}}>
            <strong style={{fontFamily: "Rubik-Medium"}}>
              Requisitos de uso
            </strong>
            <div>
              El usuario declara que:
              <ul style={{paddingLeft: "1rem"}}>
                <li>
                  Tiene la edad mínima legal requerida (generalmente 13 o 16
                  años según país).
                </li>
                <li>La información proporcionada es veraz y actualizada.</li>
                <li>
                  Utilizará la aplicación conforme a la ley y a estas
                  condiciones.
                </li>
              </ul>
              Emprende Ya puede suspender o cancelar cuentas ante
              incumplimientos o uso indebido.
            </div>
          </li>

          <li style={{color: blackWhite}}>
            <strong style={{fontFamily: "Rubik-Medium"}}>
              Registro y seguridad
            </strong>
            <div>
              El usuario es responsable de:
              <ul style={{paddingLeft: "1rem"}}>
                <li>Mantener la confidencialidad de sus credenciales.</li>
                <li>Notificar cualquier acceso no autorizado.</li>
                <li>Todas las actividades realizadas desde su cuenta.</li>
              </ul>
              Emprende Ya no se hace responsable por pérdidas derivadas del mal
              uso de la cuenta por terceros.
            </div>
          </li>
          <li style={{color: blackWhite}}>
            <strong style={{fontFamily: "Rubik-Medium"}}>
              Contenidos del usuario
            </strong>
            <div>
              El usuario puede publicar contenido como comentarios, imágenes,
              documentos o mensajes. Al hacerlo:
              <ul style={{paddingLeft: "1rem"}}>
                <li>
                  Garantiza que es propietario o tiene permiso para publicar
                  dicho contenido.
                </li>
                <li>
                  No publicará contenido ilegal, ofensivo, discriminatorio o que
                  infrinja derechos de terceros.
                </li>
                <li>
                  Concede a Emprende Ya una licencia no exclusiva y gratuita
                  para mostrar y utilizar dicho contenido dentro de la
                  plataforma, únicamente para su funcionamiento.
                </li>
              </ul>
              Emprende Ya podrá eliminar contenido que infrinja estas
              condiciones.
            </div>
          </li>
          <li style={{color: blackWhite}}>
            <strong style={{fontFamily: "Rubik-Medium"}}>
              Conductas prohibidas
            </strong>
            <div>
              Está prohibido:
              <ul style={{paddingLeft: "1rem"}}>
                <li>Usar la app con fines ilícitos.</li>
                <li>Enviar spam, fraudes o mensajes agresivos.</li>
                <li>
                  Publicar contenidos que atenten contra la integridad de otros
                  usuarios.
                </li>
                <li>
                  Manipular el funcionamiento de la plataforma, realizar
                  ingeniería inversa o introducir malware.
                </li>
                <li>Crear cuentas falsas o suplantar identidades.</li>
              </ul>
            </div>
          </li>
          <li style={{color: blackWhite}}>
            <strong style={{fontFamily: "Rubik-Medium"}}>
              Propiedad intelectual
            </strong>
            <div>
              Todos los elementos de la aplicación, incluyendo diseño, marca,
              software y contenidos propios, pertenecen a Emprende Ya o a sus
              licenciantes. Está prohibido copiar, modificar o distribuirlos sin
              autorización.
            </div>
          </li>
          <li style={{color: blackWhite}}>
            <strong style={{fontFamily: "Rubik-Medium"}}>
              Actualizaciones y modificaciones
            </strong>
            <div>
              Emprende Ya puede actualizar la plataforma, añadir funciones,
              corregir errores o suspender temporalmente el servicio sin
              responsabilidad hacia los usuarios. El uso continuado de la
              aplicación implica aceptación de futuras modificaciones de estas
              condiciones.
            </div>
          </li>
          <li style={{color: blackWhite}}>
            <strong style={{fontFamily: "Rubik-Medium"}}>
              Responsabilidad
            </strong>
            <div>
              Emprende Ya se entrega “tal cual” y no garantiza:
              <ul style={{paddingLeft: "1rem"}}>
                <li>Que funcionará sin interrupciones o errores.</li>
                <li>Que todo el contenido será exacto o actualizado.</li>
                <li>
                  Que terceros no autorizados no puedan vulnerar sistemas.
                </li>
              </ul>
              La empresa no será responsable por daños derivados del uso o
              imposibilidad de uso de la aplicación, salvo en los límites que
              imponga la ley.
            </div>
          </li>
          <li style={{color: blackWhite}}>
            <strong style={{fontFamily: "Rubik-Medium"}}>
              Servicios de terceros
            </strong>
            <div>
              La aplicación puede integrar servicios externos. Emprende Ya no se
              responsabiliza por sus contenidos, condiciones o prácticas de
              privacidad.
            </div>
          </li>
          <li style={{color: blackWhite}}>
            <strong style={{fontFamily: "Rubik-Medium"}}>
              Cancelación de cuenta
            </strong>
            <div>
              El usuario puede solicitar la eliminación de su cuenta en
              cualquier momento. Emprende Ya puede suspenderla o cancelarla ante
              violaciones a estas condiciones. La eliminación puede implicar la
              pérdida permanente de los datos asociados.
            </div>
          </li>

          <li style={{color: blackWhite}}>
            <strong style={{fontFamily: "Rubik-Medium"}}>
              Legislación aplicable
            </strong>
            <div>
              Estas condiciones se rigen por la legislación del país donde tenga
              sede la empresa operadora de Emprende Ya, salvo que la ley
              establezca lo contrario. Los conflictos se resolverán ante los
              tribunales competentes.
            </div>
          </li>
        </ol>
        <Line />
        <Typography fontFamily="Rubik-SemiBold" fontSize={18}>
          <strong style={{fontFamily: "Rubik-SemiBold"}}>
            POLÍTICA DE PRIVACIDAD DE EMPRENDE YA
          </strong>
        </Typography>
        <div style={{color: blackWhite, marginTop: "0.5rem"}}>
          Esta Política explica cómo Emprende Ya recopila, utiliza y protege la
          información personal de sus usuarios.
        </div>
        <ol style={{padding: "1rem"}}>
          <li style={{color: blackWhite}}>
            <strong style={{fontFamily: "Rubik-Medium"}}>
              Información que recopilamos
            </strong>
            <div>
              <ul style={{paddingLeft: "1rem"}}>
                <li>
                  <strong style={{fontFamily: "Rubik-Medium"}}>
                    Información proporcionada por el usuario
                  </strong>
                  <div>
                    Nombre, correo electrónico, teléfono y datos de registro.
                    Perfil, imagen, biografía u otra información suministrada
                    voluntariamente. Datos relacionados con el uso de
                    funcionalidades de emprendimiento (p. ej., metas, avances,
                    proyectos).
                  </div>
                </li>
                <li>
                  <strong style={{fontFamily: "Rubik-Medium"}}>
                    Información recopilada automáticamente
                  </strong>
                  <div>
                    Datos técnicos del dispositivo: modelo, sistema operativo,
                    IP, identificadores únicos. Datos de uso: interacciones,
                    secciones visitadas, estadísticas internas. Cookies o
                    tecnologías equivalentes (donde aplique).
                  </div>
                </li>
                <li>
                  <strong style={{fontFamily: "Rubik-Medium"}}>
                    Ubicación
                  </strong>
                  <div>
                    Podemos solicitar acceso a datos de ubicación aproximada o
                    precisa, siempre con consentimiento.
                  </div>
                </li>
                <li>
                  <strong style={{fontFamily: "Rubik-Medium"}}>
                    Datos obtenidos de terceros
                  </strong>
                  <div>
                    Si el usuario se registra mediante Google, Facebook, Apple u
                    otro proveedor, Emprende Ya recibirá únicamente los datos
                    autorizados.
                  </div>
                </li>
              </ul>
            </div>
          </li>
          <li style={{color: blackWhite}}>
            <strong style={{fontFamily: "Rubik-Medium"}}>
              Finalidades del tratamiento
            </strong>
            <div>
              Los datos se utilizan para: Gestionar cuentas y permitir el
              funcionamiento de la app. Personalizar la experiencia del usuario.
              Mejorar la plataforma mediante análisis de uso. Enviar
              notificaciones o comunicaciones relacionadas con el servicio.
              Garantizar seguridad, moderación y prevención de abusos. Cumplir
              obligaciones legales.
            </div>
          </li>
          <li style={{color: blackWhite}}>
            <strong style={{fontFamily: "Rubik-Medium"}}>
              Base legal del tratamiento
            </strong>
            <div>
              Dependiendo de la región, nos basamos en: Consentimiento del
              usuario. Necesidad contractual para prestar el servicio. Interés
              legítimo en mejorar la app y su seguridad. Cumplimiento de
              obligaciones legales.
            </div>
          </li>
          <li style={{color: blackWhite}}>
            <strong style={{fontFamily: "Rubik-Medium"}}>
              Con quién compartimos la información
            </strong>
            <div>
              Emprende Ya no vende datos personales. Podemos compartirlos con:
              Proveedores de servicios tecnológicos (hosting, almacenamiento,
              notificaciones push, analítica). Autoridades cuando la ley lo
              exija. Otros usuarios, únicamente en los casos en que el usuario
              decida compartir información dentro de la comunidad de la app.
            </div>
          </li>
          <li style={{color: blackWhite}}>
            <strong style={{fontFamily: "Rubik-Medium"}}>
              Transferencias internacionales
            </strong>
            <div>
              Si se requiere transferir datos fuera del país del usuario, se
              aplicarán medidas adecuadas para garantizar su protección
              (cláusulas contractuales, equivalencias legales o estándares
              vigentes).
            </div>
          </li>
          <li style={{color: blackWhite}}>
            <strong style={{fontFamily: "Rubik-Medium"}}>Seguridad</strong>
            <div>
              Implementamos medidas técnicas y organizativas para proteger los
              datos. No obstante, ningún sistema es completamente invulnerable.
            </div>
          </li>
          <li style={{color: blackWhite}}>
            <strong style={{fontFamily: "Rubik-Medium"}}>
              Conservación de los datos
            </strong>
            <div>
              Los datos se mantendrán mientras: La cuenta esté activa, o Sea
              necesario para cumplir obligaciones legales o resolver disputas.
              Al eliminar la cuenta, los datos serán eliminados o anonimizados
              salvo aquellos que la ley obligue a conservar.
            </div>
          </li>
          <li style={{color: blackWhite}}>
            <strong style={{fontFamily: "Rubik-Medium"}}>
              Derechos del usuario
            </strong>
            <div>
              El usuario puede ejercer los derechos de: Acceso, Rectificación,
              Eliminación, Portabilidad, Oposición, Limitación del tratamiento,
              Retiro de consentimiento. Las solicitudes podrán hacerse desde la
              app o escribiendo a: (colocar correo oficial).
            </div>
          </li>
          <li style={{color: blackWhite}}>
            <strong style={{fontFamily: "Rubik-Medium"}}>
              Menores de edad
            </strong>
            <div>
              No recopilamos datos personales de menores sin el debido
              consentimiento. Si detectamos información de menores sin
              autorización verificable, será eliminada.
            </div>
          </li>
          <li style={{color: blackWhite}}>
            <strong style={{fontFamily: "Rubik-Medium"}}>
              Cambios en la política de privacidad
            </strong>
            <div>
              Podemos actualizar esta política para reflejar cambios legales o
              funcionales. El uso continuo de la app después de las
              modificaciones implica aceptación de la nueva versión.
            </div>
          </li>
        </ol>
        <Line />
        <Column>
          <Typography fontFamily="Rubik-SemiBold" fontSize={18}>
            <strong style={{fontFamily: "Rubik-SemiBold"}}>Contacto</strong>
          </Typography>
          <Typography>
            Para preguntas o inquietudes sobre estas condiciones y políticas,
            contáctenos en:
          </Typography>

          <ul style={{padding: "0 1rem", marginBottom: "1rem"}}>
            <li style={{color: blackWhite}}>Teléfono: +58 424-5794698</li>
          </ul>
        </Column>
      </Column>
    </Column>
  );
};
